import apiClient from '../client';
import type { Fee, CreateFeePayload, UpdateFeePayload } from '@/types';

export const feesApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: Fee[] }>('/fees', { params }).then((r) => r.data.data),

  getById: (id: number) =>
    apiClient.get<{ data: Fee }>(`/fees/${id}`).then((r) => r.data.data),

  create: (payload: CreateFeePayload) =>
    apiClient.post<{ data: Fee }>('/fees', payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateFeePayload) =>
    apiClient.put<{ data: Fee }>(`/fees/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`/fees/${id}`),
};

